// extracted by mini-css-extract-plugin
module.exports = {"MainContent":"Layout_MainContent__si-xI","Footer":"Layout_Footer__2-TDv","FooterGithubLogo":"Layout_FooterGithubLogo__1CM1h"};